// Lib
import * as jsondiffpatch from 'jsondiffpatch/with-text-diffs';

/**
 * A content diff as this module produces it.
 * Diffs are persisted in client undo history, so this is a stored format, not just a value
 * passed between calls.
 */
export type ContentDiff = jsondiffpatch.Delta;

const diffPatcher = jsondiffpatch.create({
    objectHash: (node: object, index?: number) => {
        // try to find a property which uniquely identifies this object
        const keyedNode = node as { key?: string; attrs?: { key?: string } };
        return keyedNode.key || keyedNode.attrs?.key || `index: ${index}`;
    },
});

export const getContentDiff = (previousState: object, currentState: object): ContentDiff | undefined =>
    diffPatcher.diff(previousState, currentState);

export const patchContentWithDiff = (previousState: object, newChanges: object): object =>
    diffPatcher.patch(previousState, newChanges as ContentDiff) as object;

/**
 * Turns a stored content diff into the diff that undoes it, so undo can apply it with
 * `patchContentWithDiff` instead of holding a copy of the previous content.
 */
export const reverseContentDiff = (contentDiff: ContentDiff): ContentDiff => diffPatcher.reverse(contentDiff);
